import { render } from "./OnboardingView.vue?vue&type=template&id=a06ccfc4&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=a06ccfc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06ccfc4"]])

export default __exports__